const CartHeaderContainer = ({ children, title }) => (
  <div className="align-items-center border-bottom d-flex flex-wrap justify-content-between p-2">
    <h3 className="h6 uppercase m-0 text-muted text-uppercase">{title}</h3>
    {children}
  </div>
)

export default CartHeaderContainer
